import { render, staticRenderFns } from "./SmallBurningTest.vue?vue&type=template&id=7a897f62&"
import script from "./SmallBurningTest.vue?vue&type=script&lang=js&"
export * from "./SmallBurningTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports